var content = require("!!../node_modules/@teamsupercell/typings-for-css-modules-loader/src/index.js!../node_modules/css-loader/dist/cjs.js??ref--5-2!./styles.css");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
